export default "__VITE_ASSET__ookwDNlnETlFW1YWWz9xqQ__"